import { useState } from 'react';
import {
    Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner,
} from 'reactstrap';
import { BiStar, BiSolidStar } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { rateJob } from '../../api/insightsApi';

export default function RateJobModal({ isOpen, onClose, jobId }) {
    const [rating, setRating] = useState(0);
    const [hoveredStar, setHoveredStar] = useState(0);
    const [note, setNote] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async () => {
        if (!rating || submitting) return;
        setSubmitting(true);
        try {
            await rateJob(jobId, rating, note.trim() || null);
            toast.success('Job rated successfully');
            onClose();
        } catch (err) {
            toast.error(err?.message ?? 'Failed to rate job');
        } finally {
            setSubmitting(false);
        }
    };

    const handleSkip = () => {
        if (submitting) return;
        onClose();
    };

    const displayRating = hoveredStar || rating;

    return (
        <Modal isOpen={isOpen} toggle={handleSkip} centered backdrop="static">
            <ModalHeader toggle={handleSkip}>Rate this job</ModalHeader>
            <ModalBody>
                <p className="text-muted small mb-3">
                    How worthwhile was this job? Your rating helps improve AI insights.
                </p>

                <div className="d-flex gap-1 mb-3" style={{ fontSize: '2rem' }}>
                    {[1, 2, 3, 4, 5].map(star => {
                        const filled = star <= displayRating;
                        const Icon = filled ? BiSolidStar : BiStar;
                        return (
                            <Icon
                                key={star}
                                style={{
                                    cursor: 'pointer',
                                    color: filled ? '#f59e0b' : '#cbd5e1',
                                    transition: 'color 0.1s',
                                }}
                                onClick={() => setRating(star)}
                                onMouseEnter={() => setHoveredStar(star)}
                                onMouseLeave={() => setHoveredStar(0)}
                            />
                        );
                    })}
                </div>

                <textarea
                    className="form-control form-control-sm"
                    rows={3}
                    placeholder="Any notes? (optional)"
                    value={note}
                    onChange={e => setNote(e.target.value)}
                />
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" outline onClick={handleSkip} disabled={submitting}>
                    Skip
                </Button>
                <Button color="primary" onClick={handleSubmit} disabled={!rating || submitting}>
                    {submitting && <Spinner size="sm" className="me-1" />}
                    Submit
                </Button>
            </ModalFooter>
        </Modal>
    );
}
